import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import caBanner from "../images/painting-1.png";
import caBig from "../images/painting-2.png";
import caCollage from "../images/painting-3.png";

import {
  FaPaintBrush,
  FaPalette,
  FaChild,
  FaBrain,
  FaGraduationCap,
  FaStar
} from "react-icons/fa";

function CreativeArts() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sidebar = [
    { title: "Painting & Creative Arts Curriculum", icon: FaPaintBrush },
    { title: "Boosts Creativity & Imagination", icon: FaPalette },
    { title: "Improves Motor & Cognitive Skills", icon: FaBrain },
    { title: "Age-Appropriate Learning Modules", icon: FaChild },
    { title: "Certified Art Trainers", icon: FaGraduationCap },
    { title: "Student Portfolio & Exhibitions", icon: FaStar },
  ];

  const features = [
    "Structured art & craft programs",
    "Drawing, painting & mixed media",
    "Skill-based creative progression",
    "Art exhibitions & assessments",
    "Materials & trainer support",
  ];

  return (
    <ServiceTemplate
      title="PAINTING & CREATIVE ARTS PROGRAM"
      bannerImage={caBanner}
      bigImage={caBig}
      collageImage={caCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}

export default CreativeArts;
